var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 15.75H13.0594L7.95938 12.1875V5.95312L11.5594 8.625L13.3594 6.84375M7.95938 2.39062C7.95938 2.62683 8.0542 2.85337 8.22298 3.02039C8.39176 3.18742 8.62068 3.28125 8.85938 3.28125C9.09807 3.28125 9.32699 3.18742 9.49577 3.02039C9.66455 2.85337 9.75938 2.62683 9.75938 2.39062C9.75938 2.15442 9.66455 1.92788 9.49577 1.76086C9.32699 1.59383 9.09807 1.5 8.85938 1.5C8.62068 1.5 8.39176 1.59383 8.22298 1.76086C8.0542 1.92788 7.95938 2.15442 7.95938 2.39062Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPray);
export default __webpack_public_path__ + "static/media/pray.76e541f54d7091e3ce87568114654088.svg";
export { ForwardRef as ReactComponent };